import React, {useContext, useEffect, useState, Fragment} from "react";
import TableSection from 'components/sales/tableSection/tableSection';
import localization from 'assets/localization/localization';
import {BaseUrl} from "../../../contexts/baseUrl/baseUrl";
import Layout from "../../../components/sales/layout/layout";

const RequestTransactionDetails = ({
    history,
    match,
    requesttransactionList,
    requesttransactionListDetails = [],
}) => {

    const [isLoading, setIsLoading] = useState(false);
    const [pageCount, setPageCount] = useState(0);
    const {baseUrl} = useContext(BaseUrl);
    const [listData, setListData] = useState();
    const [isModal, setIsModal] = useState(false);
    const role = JSON.parse(localStorage.getItem('roles'));
    const [roleId, setRoleId] = useState('');

    useEffect(() => {
        (async () => {
            role && setRoleId(role[0].pivot.role_id);
          })();
    },[role]);

    const handleModalHide = () => {
        setIsModal(false);
        window.location.reload();
    }

    useEffect(() => {
        if(match.params.id !== undefined) { console.log(match.params.id);
        (async () => {
            setIsLoading(true)
            await requesttransactionList(match?.params?.id)
            setIsLoading(false)
        })()
    }
    }, []);


    const headers = [
        'Requested Amount',
        'Wallet Type',
        'Remark',
        'Status',
        'Created at',
    ];

    const onPageChange = async (val) => {
        setIsLoading(true);
        await requesttransactionList(match?.params?.id);
        setIsLoading(false);
    };

    // {console.log(requesttransactionListDetails)}
    useEffect(() => {
        if (requesttransactionListDetails &&
            requesttransactionListDetails?.data !== undefined && requesttransactionListDetails?.data?.data !== undefined && requesttransactionListDetails?.data?.data.length > 0) {
            const tableData = ['id', 'requested_amount', 'wallet_type', 'remark', 'status', 'created_at'];
            const data = requesttransactionListDetails?.data?.data.map((element) =>
                Object.assign(
                    ...tableData.map((key) => (
                        key === 'status' && parseInt(element['status']) === 1 ? {[key]: 'Pending'} :
                            key === 'status' && parseInt(element['status']) === 2 ? {[key]: 'Complete'} :
                                key === 'status' && parseInt(element['status']) === 3 ? {[key]: 'Failed'} :
                                            {[key]: element[key]}
                    )),
                )
            )
            if (data) {
                data && setListData(data);
            }
            setPageCount(Math.ceil(requesttransactionListDetails?.data.total / requesttransactionListDetails?.data?.per_page));
        }
    }, [requesttransactionListDetails])

    return (
        <>
            <Layout
                title={localization.transactionList}
                isLoading={isLoading}
                isGoback={true}
            >
            <TableSection
                data={listData}
                isId={false}
                isMngId={false}
                headers={headers}
                pageCount={pageCount}
                onPageChange={onPageChange}
                detailList={requesttransactionListDetails?.data && requesttransactionListDetails?.data}
                srNo={requesttransactionListDetails?.from}
            />
            </Layout>
        </>
    )
}

export default RequestTransactionDetails

